import { Component, Input, OnInit } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { EmployeeService } from '../../services/employees.service';
import {
    CarrierTeamType
    , Employee
    , SearchCarrierTeam
    , SearchEmployeeGroup
} from '../../models/models';

@Component({
    selector: 'carrier-team-assigned',
    templateUrl: './carrier-team-assigned.component.html',
    standalone: false
})
export class CarrierTeamAssigned implements OnInit {
    @Input() carrierID: number = 0;
    public isLoading: boolean = false;

    public employeeList: Employee[] = [];
    public searchCarrierTeamList: SearchCarrierTeam[] = [];
    public carrierTeamTypeList: CarrierTeamType[] = [];
    public isCSSupervisor: boolean = false;

    constructor(private cseService: CSEService, private employeeService: EmployeeService) {
    }

    ngOnInit() {
        this.getEmployees();
        this.getIsCSSupervisor();
    }

    private getEmployees() {
        this.isLoading = true;
        this.employeeService.getEmployeesByGroupName('CarrierRep').subscribe(result => {
            this.isLoading = false;
            this.employeeList = result;

            this.getCarrierTeamTypes();
            this.getSearchCarrierTeam();
        });
    }

    private getIsCSSupervisor() {
        var employeeId = parseInt(localStorage.getItem('EmployeeId')!);
        this.employeeService.getSearchEmployeeGroupByEmployeeID(employeeId).subscribe(result => {
            var groupList: SearchEmployeeGroup[] = result.resultCollection;
            var idx = groupList.findIndex(t => t.groupName == "CS Supervisors");
            if (idx >= 0) {
                this.isCSSupervisor = true;
            }
            else {
                this.isCSSupervisor = false;
            }
        });

        //var employeeRoles = localStorage.getItem('EmployeeRoles');
        //if (employeeRoles != null && employeeRoles.length > 0) {
        //    if (employeeRoles.indexOf('Carrier Sales Manager') > -1) return true;
        //}
    }

    private getCarrierTeamTypes() {
        this.isLoading = true;
        this.cseService.getCarrierTeamTypes().subscribe(result => {
            this.isLoading = false;
            this.carrierTeamTypeList = result.resultCollection;
        });
    }

    private getSearchCarrierTeam() {
        this.isLoading = true;
        this.cseService.getSearchCarrierTeamByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.searchCarrierTeamList = result.resultCollection;
        });
    }

    public isEmployeeCarrierTeamType(carrierTeamTypeID: number, employeeID: number) {
        var idx = this.searchCarrierTeamList.findIndex(t => t.carrierTeamTypeID == carrierTeamTypeID && t.employeeID == employeeID);
        //console.log("isEmployeeCarrierTeamType", teamTypeID, employeeID, idx);
        if (idx >= 0) {
            return true;
        }
        else {
            return false;
        }
    }

    public setEmployeeCarrierTeamMap(carrierTeamTypeID: number, evt: any) {
        var employeeID: number = 0;
        if (evt.target) {
            employeeID = evt.target.value;
        }
        this.isLoading = true;
        this.cseService.saveCarrierTeamMap(this.carrierID, carrierTeamTypeID, employeeID).subscribe(result => {
            this.isLoading = false;
            console.log("setEmployeeCarrierTeamMap", carrierTeamTypeID, employeeID, evt, result);
        });
    }
}
